import { createBrowserRouter } from "react-router-dom";
import UserManage from "pages/UserManager";
import OrgManager from "pages/OrgManager";
import Profile from "pages/Profile";
import HomeLayout from "../layout/HomeLayout";
import { CommonStateEnum } from "../types/common";
import LoginLayout from "../layout/LoginLayout";
import IndexHome from "../layout";
import ProductCategory from "../pages/ProductCategory";
// import OrderView from "../pages/StoreManager/subPages/Order";
import CountingView from "../pages/StoreManager/subPages/CountingView";

import ProductManager from "../pages/Product";
import AppManager from "../pages/AppManager";
import NotFoundPage from "@/pages/NotFound";
import SalesReviews from "@/pages/Sales/pages/Review";
import SalesCustomers from "@/pages/Sales/pages/Customer";
import SalesPrice from "@/pages/Sales/pages/Price";
import SalesOrders from "@/pages/Sales/pages/Order";
import DataReport from "@/pages/Data";
import SalesEntry from "@/pages/Sales/pages/Entry";
import ProductInfo from "@/pages/Sales/pages/ProductInfo";

import InventoryView from "@/pages/Warehouse/pages/Inventory";
import OrderManage from "@/pages/Warehouse/pages/OrderManage";
import InventoryManage from "@/pages/Warehouse/pages/InventoryManage";
import LocationManage from "@/pages/Warehouse/pages/LocationManage";
import Bom from "@/pages/Bom";
import Supplier from "@/pages/Purchase/pages/Supplier";
import OrderView from "@/pages/Warehouse/pages/Order";
import PurchaseOrderHome from "@/pages/Purchase/pages/Order";
import Category from "@/pages/Purchase/pages/Category";
import PriceManage from "@/pages/Purchase/pages/PriceManage";
import RequirementList from "@/pages/Requirement/pages/List";
import QuotationList from "@/pages/Requirement/pages/QuotationList";
import WelcomePage from "@/pages/WelcomePage";
import SupplierLogin from "@/SupplierPages/Login";
import RequestHome from "@/SupplierPages/Home/Request";
import SupplierPagesHome from "@/SupplierPages/Home";
import SupplierOrders from "@/SupplierPages/Home/Order";
import SupplierQuotationList from "@/SupplierPages/Home/Bussiness/SupplierPrice";
import InventoryOrder from "@/SupplierPages/Home/InventoryOrder";
import ReimburseHome from "@/pages/Reimburse";
import MaterialOverIssueList from "@/pages/Requirement/pages/MaterialOverIssueList";
import InventoryDetailList from "@/pages/Warehouse/pages/InventoryDetailList";
import PurchasedItems from "@/pages/Warehouse/pages/InventoryDetailList/PurchasedItems";
import LocInvDetail from "@/pages/Warehouse/pages/LocInvDetail";
import LocationRefProducts from "@/pages/Warehouse/pages/LocationRefProducts";
import SupplierPriceList from "@/pages/Purchase/pages/Supplier/pages/Price/PriceList";
import InventoryAlert from "@/pages/InventoryAlert";
import IQCList from "@/pages/Warehouse/pages/IQCList";
import FactoryInventory from "@/pages/Warehouse/pages/FactoryInventory";
import Packing from "@/pages/Warehouse/pages/Packing";
import ShipmentListPage from "@/pages/Shipment/pages/ShipmentListPage";
import InspectionHome from "@/pages/Warehouse/pages/Inspection";
import InpectionItemHome from "@/pages/Warehouse/pages/Inspection/components/InspectionListDtl/InpectionItemHome";
import Equipment from "@/pages/Equipment";

export enum ROUTER_KEYS {
  APP = "/",
  LOGIN = "/login",
  HOME = "/home",
  WELCOME = "/home/index",
  // sales
  SALES = "/home/sales",
  SALES_ORDER = "/home/sales/order",
  SALES_PRICE = "/home/sales/price",
  SALES_CUSTOMER = "/home/sales/customer",
  SALES_DATA = "/home/sales/data",
  SALES_REVIEWS = "/home/sales/reviews",
  SALES_DATA_MAINTAIN = "/home/sales/data/maintain",
  SALES_PRODUCT_INFO = "/home/sales/product/info",

  //data
  DATA = '/home/data',
  DATA_REPORTS = "/home/data/reports",

  // warehouse
  WAREHOUSE = "/home/warehouse",
  WAREHOUSE_INVENTORY = "/home/warehouse/inventory",
  WAREHOUSE_ORDER = "/home/warehouse/order",
  WAREHOUSE_COUNTING = "/home/warehouse/counting",
  WAREHOUSE_ORDERMANAGE = "/home/warehouse/order_manage",
  WAREHOUSE_INVENTORY_MANAGE = "/home/warehouse/inventory_manage",
  WAREHOUSE_INVENTORY_DETAIL = "/home/warehouse/inventory_detail",
  LOC_INV_DTL = "/home/warehouse/loc_inv_dtl",
  WAREHOUSE_LOCATION_REF_PRODUCTS = "/home/warehouse/location_ref_products",
  WAREHOUSE_IQC = "/home/warehouse/iqc",
  FAC_INVENTORY = "/home/warehouse/factory",
  PACKING = "/home/warehouse/packing",
  INSPECTION = "/home/warehouse/inspection",
  INSPECTION_ITEM = "/home/warehouse/inspection_item",
  // bom
  BOM = '/home/bom',

  STORE_PRODUCT_CATEGORY_MANAGER = "/home/store/product_category",
  ORG_MANAGER = "/home/org",
  ORG_DISABLED_MANAGER = "/home/org",
  USER_MANAGER = "/home/user",
  USER_DISABLED_MANAGER = "/home/user/disabled",
  USER_ENABLED_MANAGER = "/home/user/enabled",
  APP_MANAGER = "/home/app",
  STORE_PRODUCT_MANAGER = "/home/product",
  PROFILE = "/profile",

  // 物控
  MATERIAL = '/home/material',
  MATERIAL_SALE_ORDER = '/home/material/order_list',
  MATERIAL_INVENTORY_ALERT = '/home/material/inventory_alert',
  // MATERIAL_REQUIREMENT = '/home/material/requirement_list',

  // purchase
  PURCHASE = '/home/purchase',
  PURCHASE_SUPPLIER = "/home/purchase/supplier",
  PURCHASE_PRICES = "/home/purchase/price/list",
  PURCHASE_DIS_SUPPLIER = "/home/purchase/dis_supplier",
  PURCHASE_ORDER = "/home/purchase/order",
  PURCHASE_CATEGORY = "/home/purchase/category",
  PRICE_MANAGE = "/home/purchase/price_manage",
  PUR_INV_ITEM = "/home/purchase/inv_items",

  PURCHASE_OPTION = "/home/opt/purchase",
  PURCHASE_OPTION_MANUAL = "/home/opt/purchase/manual",
  PURCHASE_MATERIAL_TRACK = "/home/opt/purchase/material",
  PURCHASE_RETURN = "/home/opt/purchase/return",
  // PURCHASE_REQUIREMENT_PASSED = '/home/purchase/requirement_list_passed', // 采购已审批的订单
  // PURCHASE_REQUIREMENT_NOT_PASS = '/home/purchase/requirement_list_not_pass', // 采购未审批的订单
  // PURCHASE_REQUIREMENT_PASSED_ORDER = '/home/purchase/requirement_list_passed', // 业务已通过的订单,需要一键采购的任务

  REQUIREMENT_LIST = '/home/requirement',
  QUOTATION_LIST = '/home/requirement/quotation',
  PROD_MATERIAL_OVER_ISSUE = "/home/material_over_issue",

  REIMBURSE_MINE = "/home/reimburse/mine",
  REIMBURSE_APPROVE = "/home/reimburse/approve",
  REIMBURSE_ALL = "/home/reimburse/all",


  // 供应商页面
  SUPPLIER_LOGIN = '/s2/login',
  SUPPLIER_HOME = '/s2/hm',
  SUPPLIER_REQUEST_HOME = '/s2/hm/R',
  SUPPLIER_PURCHASE_HOME = '/s2/hm/P',
  SUPPLIER_DELIVERY_NOTICE = '/s2/hm/DN',
  SUPPLIER_BUSSINESS_RECONCILIATION = '/s2/hm/BS/R',
  SUPPLIER_BUSSINESS_CONTTRACT = '/s2/hm/BS/C',
  SUPPLIER_BUSSINESS_QUOTATION = '/s2/hm/BS/Q',

  //数据管理（供应商管理）
  DATA_MANAGE = '/home/supplier',

  // 运输管理
  SHIPMENT = '/home/shipment',
  SHIPMENT_LIST = '/home/shipment/list',

  // 设备管理
  EQUIPMENT = "/home/equipment",
}

export const router = createBrowserRouter([
  {
    path: ROUTER_KEYS.APP,
    element: <IndexHome />,
    children: [
      {
        path: ROUTER_KEYS.LOGIN,
        element: <LoginLayout />,
      },
      {
        path: ROUTER_KEYS.HOME,
        element: <HomeLayout />,
        children: [
          {
            path: ROUTER_KEYS.USER_ENABLED_MANAGER,
            element: <UserManage status={CommonStateEnum.ACTIVE} />
          },
          {
            path: ROUTER_KEYS.USER_DISABLED_MANAGER,
            element: <UserManage status={CommonStateEnum.UN_ACTIVE} />
          },
          { path: ROUTER_KEYS.ORG_DISABLED_MANAGER, element: <OrgManager status={CommonStateEnum.ACTIVE} /> },
          { path: ROUTER_KEYS.BOM, element: <Bom /> },
          { path: ROUTER_KEYS.SALES_CUSTOMER, element: <SalesCustomers /> },
          { path: ROUTER_KEYS.SALES_PRICE, element: <SalesPrice /> },
          { path: ROUTER_KEYS.SALES_ORDER, element: <SalesOrders /> },
          { path: ROUTER_KEYS.SALES_DATA, element: <SalesEntry /> },
          { path: ROUTER_KEYS.SALES_REVIEWS, element: <SalesReviews /> },
          { path: ROUTER_KEYS.MATERIAL_SALE_ORDER, element: <SalesOrders /> },
          { path: ROUTER_KEYS.MATERIAL_INVENTORY_ALERT, element: <InventoryAlert /> },
          { path: ROUTER_KEYS.PURCHASE_SUPPLIER, element: <Supplier /> },
          { path: ROUTER_KEYS.PURCHASE_PRICES, element: <SupplierPriceList /> },
          { path: ROUTER_KEYS.PURCHASE_DIS_SUPPLIER, element: <Supplier /> },
          { path: ROUTER_KEYS.QUOTATION_LIST, element: <QuotationList /> },
          { path: ROUTER_KEYS.PURCHASE_ORDER, element: <PurchaseOrderHome /> },
          { path: ROUTER_KEYS.PURCHASE_CATEGORY, element: <Category /> },
          { path: ROUTER_KEYS.PRICE_MANAGE, element: <PriceManage /> },
          { path: ROUTER_KEYS.PUR_INV_ITEM, element: <PurchasedItems /> },

          { path: ROUTER_KEYS.PURCHASE_OPTION_MANUAL, element: <RequirementList /> },
          { path: ROUTER_KEYS.PURCHASE_MATERIAL_TRACK, element: <PurchaseOrderHome /> },
          { path: ROUTER_KEYS.PURCHASE_RETURN, element: <PurchaseOrderHome /> },

          { path: ROUTER_KEYS.REQUIREMENT_LIST, element: <RequirementList /> },
          { path: ROUTER_KEYS.PROD_MATERIAL_OVER_ISSUE, element: <MaterialOverIssueList /> },
          { path: ROUTER_KEYS.DATA_REPORTS, element: <DataReport /> },
          { path: ROUTER_KEYS.SALES_PRODUCT_INFO, element: <ProductInfo /> },
          { path: ROUTER_KEYS.WAREHOUSE_INVENTORY, element: <InventoryView /> },
          { path: ROUTER_KEYS.WAREHOUSE_ORDER, element: <OrderView /> },
          { path: ROUTER_KEYS.WAREHOUSE_COUNTING, element: <CountingView /> },
          { path: ROUTER_KEYS.WAREHOUSE_ORDERMANAGE, element: <OrderManage /> },
          { path: ROUTER_KEYS.WAREHOUSE_INVENTORY_MANAGE, element: <LocationManage /> },
          { path: ROUTER_KEYS.WAREHOUSE_INVENTORY_DETAIL, element: <InventoryDetailList /> },
          { path: ROUTER_KEYS.LOC_INV_DTL, element: <LocInvDetail /> },
          { path: ROUTER_KEYS.WAREHOUSE_LOCATION_REF_PRODUCTS, element: <LocationRefProducts /> },
          { path: ROUTER_KEYS.WAREHOUSE_IQC, element: <IQCList /> },
          { path: ROUTER_KEYS.PACKING, element: <Packing /> },
          { path: ROUTER_KEYS.INSPECTION, element: <InspectionHome /> },
          { path: ROUTER_KEYS.INSPECTION_ITEM, element: <InpectionItemHome /> },
          { path: ROUTER_KEYS.FAC_INVENTORY, element: <FactoryInventory /> },
          { path: ROUTER_KEYS.APP_MANAGER, element: <AppManager /> },
          { path: ROUTER_KEYS.STORE_PRODUCT_MANAGER, element: <ProductManager /> },
          { path: ROUTER_KEYS.STORE_PRODUCT_CATEGORY_MANAGER, element: <ProductCategory /> },
          { path: ROUTER_KEYS.DATA_MANAGE, element: <Supplier /> },
          { path: ROUTER_KEYS.WELCOME, element: <WelcomePage /> },
          { path: ROUTER_KEYS.SALES_DATA_MAINTAIN, element: <div>正在开发中</div> },

          { path: ROUTER_KEYS.REIMBURSE_MINE, element: <ReimburseHome /> },
          { path: ROUTER_KEYS.REIMBURSE_APPROVE, element: <ReimburseHome /> },
          { path: ROUTER_KEYS.REIMBURSE_ALL, element: <ReimburseHome /> },
          { path: ROUTER_KEYS.SHIPMENT_LIST, element: <ShipmentListPage /> },
          { path: ROUTER_KEYS.EQUIPMENT, element: <Equipment /> },
        ],
      },
      {
        path: ROUTER_KEYS.SUPPLIER_LOGIN,
        element: <SupplierLogin />,
      },
      {
        path: ROUTER_KEYS.SUPPLIER_HOME,
        element: <SupplierPagesHome />,
        children: [
          { index: true, path: ROUTER_KEYS.SUPPLIER_REQUEST_HOME, element: <RequestHome /> },
          { path: ROUTER_KEYS.SUPPLIER_PURCHASE_HOME, element: <SupplierOrders /> },
          { path: ROUTER_KEYS.SUPPLIER_DELIVERY_NOTICE, element: <InventoryOrder /> },
          { path: ROUTER_KEYS.SUPPLIER_BUSSINESS_RECONCILIATION, element: <div>正在开发中</div> },
          { path: ROUTER_KEYS.SUPPLIER_BUSSINESS_CONTTRACT, element: <div>正在开发中</div> },
          { path: ROUTER_KEYS.SUPPLIER_BUSSINESS_QUOTATION, element: <SupplierQuotationList /> },
        ]
      }
    ]
  },
  {
    path: ROUTER_KEYS.PROFILE,
    element: <Profile />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  }
]);
